import * as React from 'react';
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";

interface IProps {
    data: any;
    templateName?: string;
}

class NotificationTemplateContent extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const shouldNotShow = Object.keys(this.props.data).length !== 0;
        return (
            <div>
                <br/>
                {shouldNotShow &&
                <h4>{this.props.templateName}</h4>}
                {shouldNotShow && <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>
                    <JsonRenderComponent jsonObject={this.props.data} printHtml={true}/>
                </p>}
            </div>
        );
    }
}

export default NotificationTemplateContent;
